import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";

import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ServiceInterceptor } from "./core/helpers/service.interceptor";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { SharedModule } from "./shared/shared.module";
import { AlertifyService } from "./core/services/alertify.service";
import { LoginGuard } from "./core/guards/login.guard";

import { LoadingScreenComponent } from "./core/layouts/loading-screen/loading-screen.component";
import { DateFormatPipe } from '../app/core/pipes/date-format.pipe';

import { BaseService} from './core/services/base-service/base-service'
@NgModule({
  declarations: [AppComponent, LoadingScreenComponent, DateFormatPipe],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ServiceInterceptor, multi: true },
    AlertifyService,
    LoginGuard,
    BaseService
  ],
  exports: [
    DateFormatPipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
